import React from "react";

function Hero() {
    return ( 
          <div className="container ">
            <div className="row text-center mt-3 mb-5 " >
                <h1 className="mt-5 pt-5 mb-3 text-muted" style={{fontSize:"3rem"}}>
                    Charges
                </h1>
                <p className="mb-5 text-muted fs-4 pb-5">List of all charges and taxes</p>
            </div>
            <div className="row mt-5 pt-5 text-center">
                <div className="col-4">
                    <img style={{height:"45%"}}src="media/pricingEquity.svg"/>
                    <h1 className="fs-2">Free equity delivery</h1>
                    <p className="text-muted p-4">All equity delivery investments (NSE,BSE), are absolutely free - ₹ 0 brokerage.</p>

                </div>
                <div className="col-4">
                    <img style={{height:"45%"}} src="media/intradayTrades.svg"/>
                    <h1 className="fs-2">Intraday and F&O trades</h1>
                    <p className="text-muted p-4">Flat ₹ 20 or 0.03% (whichever is lower) per executed order on intraday trades across equity, currency, and commodity trades. Flat ₹20 on all option trades.</p>

                </div>
                <div className="col-4">
                    <img style={{height:"45%"}} src="media/pricingEquity.svg"/>
                    <h1 className="fs-2">Free direct MF</h1>
                    <p className="text-muted p-4">All direct mutual fund investments are absolutely free — ₹ 0 commissions & DP charges.</p>

                </div>

            </div>
        </div>
     );
}

export default Hero;